import React, {PropsWithChildren} from 'react';
import clsx from 'clsx';

import styles from './Description.module.css';

interface DetailProps {
  title: string
  className?: string
}


const Description = (props: PropsWithChildren<DetailProps>) => {
  return (
    <div className={props.className}>
      <span className="text is-title-small" data-manabie="title">{props.title}</span>
      <div className={clsx(styles.main, 'text is-title')} data-manabie="content">
        {props.children}
      </div>
    </div>
  );
};

export default Description;
